import React, { useContext } from "react";
import { Scanner } from "@yudiel/react-qr-scanner";
import { PageContext } from "../../App";

function QRScannerView() {
  //get context
  const { scanResult, setScanResult } = useContext(PageContext);

  return (
    <div className="container mt-5">
      <Scanner
        onScan={(codes) => {
          //new codes
          const newCodes = [...scanResult.result, codes];
          //set scan result
          setScanResult({ ...scanResult, error: null, result: newCodes });
        }}
        onError={(error) => {
          //set scan result
          setScanResult({ ...scanResult, error: error?.message, result: [] });
        }}
      />
    </div>
  );
}

export default QRScannerView;
